import { UsedLoaderModel } from './used-loader.model';
import { LoaderNameType } from '../types';

export class UsedLoadersModel {
  private data: object = {};

  public set(_loaderName: LoaderNameType, _usedLoaderInstance: UsedLoaderModel): void {
    this.data[_loaderName] = _usedLoaderInstance;
  }

  public isUsed(_loaderName: LoaderNameType): boolean {
    let usedLoader: UsedLoaderModel | null = this.get(_loaderName);
    let usedLoaderCount: number = usedLoader ? usedLoader.count : 0;

    return usedLoaderCount > 0;
  }

  public create(_loaderName: LoaderNameType): void {
    if (!this.data[_loaderName]) {
      this.set(_loaderName, new UsedLoaderModel());
    }
  }

  public get(_loaderName: LoaderNameType): UsedLoaderModel {
    this.create(_loaderName);

    return this.data[_loaderName];
  }
}
